import { newE2EPage } from "@stencil/core/testing";

function generateGroupedList() {
    const groups = generateFlatList(3, "Group");
    // eslint-disable-next-line
    groups.forEach((group) => (group.value = generateFlatList(10) as any));
    return groups;
}

function generateFlatList(n = 10, name = "Item") {
    return Array.from(Array(n), (_, i) => {
        return {
            id: i,
            value: i,
            name: `${name} ${i}`,
            icon: null
        };
    });
}

const items = generateFlatList();
const groupedItems = generateGroupedList();

describe("uic-filter", () => {
    describe("data binding", () => {
        it("should map common props", async () => {
            // this is the only snapshot test for uic-filter
            // we check if user-facing props are mapped correctly

            const page = await newE2EPage({
                // the min-width here ensures that the simplebar-placeholder is rendered identical on all machines.
                html: `
                <style>uic-footer{min-width: 300px;}</style>
                <uic-filter
                    label="Label"
                    bind-label="name"
                    search-placeholder-test="Search..."
                    reset-selection-text="Reset"
                    confirm-selection-text="Confirm">
                </uic-filter>`
            });

            const component = await page.find("uic-filter");
            component.setProperty("items", items);
            await page.waitForChanges();
            expect(component).toMatchSnapshot();
        });

        it("should map value using bindValue", async () => {
            const page = await newE2EPage({
                html: `<uic-filter bind-value="name"></uic-filter>`
            });

            const component = await page.find("uic-filter");
            const uicChange = await component.spyOnEvent("uicChange");
            component.setProperty("items", items);
            await page.waitForChanges();

            await component.click();

            const listItem = await page.find("uic-check-list-item uic-checkbox");

            await listItem.click();

            await page.waitForChanges();

            const confirmEl = await page.find("uic-filter uic-button[variant='footer-primary']");
            await confirmEl.click();

            await page.waitForChanges();

            expect(uicChange).toHaveReceivedEventTimes(1);
        });

        it("should map value using grouping", async () => {
            const page = await newE2EPage({
                html: `<uic-filter multiple></uic-filter>`
            });

            const component = await page.find("uic-filter");

            // NOTE: spamming page.waitForChanges when setting multiple properties seems to help getting consistent test results

            component.setProperty("groupBy", "value");
            await page.waitForChanges();

            component.setProperty("groupValueFn", (group) => group.value.name);
            await page.waitForChanges();

            component.setProperty("items", groupedItems);
            await page.waitForChanges();

            component.setProperty("value", ["Group 0"]);
            await page.waitForChanges();

            const valueText = (await component.find(".uic-filter__value")).innerText;
            expect(valueText).toBe("Group 0");
        });
    });

    describe("events", () => {
        it("should not emit uicChange when setting values externally", async () => {
            const page = await newE2EPage({
                html: `<uic-filter bind-value="value"></uic-filter>`
            });

            const component = await page.find("uic-filter");
            const uicChange = await component.spyOnEvent("uicChange");

            component.setProperty("items", items);
            component.setProperty("value", [1, 2]);

            page.waitForChanges();

            expect(uicChange).toHaveReceivedEventTimes(0);
        });
    });

    describe("hoisting embedded popover", () => {
        it("is disabled by default", async () => {
            const page = await newE2EPage({
                html: `<uic-filter></uic-filter>`
            });

            const hoisted = await page.$eval("uic-filter uic-popover", (element) => (element as HTMLUicPopoverElement).hoist);

            expect(hoisted).toBe(false);
        });

        it("is enabled by setting hoist attribute on containing uic-filter", async () => {
            const page = await newE2EPage({
                html: `<uic-filter hoist></uic-filter>`
            });

            const hoisted = await page.$eval("uic-filter uic-popover", (element) => (element as HTMLUicPopoverElement).hoist);

            expect(hoisted).toBe(true);
        });
    });

    describe("optional prelabel icons", () => {
        it(
            "should show optional icons between labels and checkboxes" + " by passing the icon name as a string to the input value",
            async () => {
                const page = await newE2EPage({
                    // the min-width here ensures that the simplebar-placeholder is rendered identical on all machines.
                    html: `
                <style>uic-footer{min-width: 300px;}</style>
                <uic-filter
                    label="Label"
                    bind-label="name"
                    search-placeholder-test="Search..."
                    reset-selection-text="Reset"
                    confirm-selection-text="Confirm">
                </uic-filter>`
                });

                const component = await page.find("uic-filter");
                component.setProperty(
                    "items",
                    items.map((item) => {
                        item.icon = "uic:square-black";
                        return item;
                    })
                );
                await page.waitForChanges();
                expect(component).toMatchSnapshot();
            }
        );
    });
});
